<template>
<svg width="22" height="13" viewBox="0 0 22 13" xmlns="http://www.w3.org/2000/svg">
    <path d="M11 12.54a1.54 1.54 0 01-1.09-.45L.452 2.63A1.54 1.54 0 112.631.451L11 8.821l8.37-8.37a1.54 1.54 0 012.178 2.18L12.09 12.09c-.3.3-.695.45-1.089.45z" />
</svg>

</template>